(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numia2topp2"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('numia-pdp-rest')) return;

  class NumiaPdpRest extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      const configNode = this.querySelector('[data-numia-rest-config]');
      try { this.config = JSON.parse(configNode?.textContent || '{}'); }
      catch (_) { this.config = {}; }

      this.querySelectorAll('[data-numia-scroll-buy]').forEach(button => {
        button.addEventListener('click', () => this.scrollToBuy(), { signal: this.signal });
      });

      this.initStickyVisibility();
      this.initBeforeAfter();
      this.initReviews();
      this.initTimer();
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      clearInterval(this.timer);
      this.initialized = false;
    }

    initStickyVisibility() {
      const sticky = this.querySelector('[data-numia-sticky]');
      if (!sticky) return;

      // Keep the sticky bar visible after this section ends. Only its START is a threshold.
      const update = () => {
        const sectionStart = this.getBoundingClientRect().top + window.scrollY;
        sticky.classList.toggle('numia-sticky--visible', window.scrollY >= sectionStart);
      };
      window.addEventListener('scroll', update, { passive: true, signal: this.signal });
      window.addEventListener('resize', update, { passive: true, signal: this.signal });
      update();
    }

    scrollToBuy() {
      const selector = this.getAttribute('data-buy-selector');
      const buySection = (selector && document.querySelector(selector)) || document.querySelector('[data-type="add-to-cart-form"]');
      if (!buySection) return;
      const target = buySection.querySelector('.numia-top__offer-heading, [id^="NumiaPackages-"], .numia-top__offer, [data-numia-cards]') || buySection;
      const y = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      const focusTarget = buySection.querySelector('.numia-card[aria-checked="true"], [data-numia-pack][aria-checked="true"], .numia-top__submit:not([disabled])');
      if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 650);
    }

    initBeforeAfter() {
      const box = this.querySelector('[data-numia-ba]');
      if (!box) return;
      const slides = Array.from(box.querySelectorAll('[data-ba-slide]'));
      const prev = box.querySelector('[data-ba-prev]');
      const next = box.querySelector('[data-ba-next]');
      const counter = box.querySelector('[data-ba-counter]');
      if (!slides.length) return;
      let current = 0;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        if (counter) counter.textContent = slides.length > 1 ? `${current + 1} / ${slides.length}` : '';
        if (prev) prev.hidden = false;
        if (next) next.hidden = false;
      };
      prev?.addEventListener('click', () => show(current - 1), {signal:this.signal});
      next?.addEventListener('click', () => show(current + 1), {signal:this.signal});
      let start = null;
      box.querySelector('[data-ba-viewport]')?.addEventListener('touchstart', e => {start = e.touches[0]?.clientX ?? null;}, {signal:this.signal, passive:true});
      box.querySelector('[data-ba-viewport]')?.addEventListener('touchend', e => {
        if(start === null) return;
        const delta = (e.changedTouches[0]?.clientX ?? start) - start;
        if(Math.abs(delta) > 35) show(current + (delta < 0 ? 1 : -1));
        start = null;
      }, {signal:this.signal, passive:true});
      show(0);
    }

    initReviews() {
      this.reviewRoot = this.querySelector('[data-numia-reviews]');
      if (!this.reviewRoot) return;
      this.track = this.reviewRoot.querySelector('[data-review-track]');
      this.cards = Array.from(this.reviewRoot.querySelectorAll('[data-review-card]'));
      this.dots = Array.from(this.reviewRoot.querySelectorAll('[data-review-dot]'));
      this.reviewIndex = 0;
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => this.showReview(Number(dot.dataset.reviewDot)), { signal: this.signal });
      });
      let startX = null;
      this.track?.addEventListener('pointerdown', event => { startX = event.clientX; }, { signal: this.signal });
      this.track?.addEventListener('pointerup', event => {
        if (startX === null) return;
        const distance = event.clientX - startX;
        startX = null;
        if (Math.abs(distance) < 35) return;
        this.showReview(this.reviewIndex + (distance < 0 ? 1 : -1));
      }, { signal: this.signal });
      window.addEventListener('resize', () => this.showReview(this.reviewIndex, false), { signal: this.signal });
      this.showReview(0, false);
    }

    showReview(index, animate = true) {
      if (!this.track || !this.cards.length) return;
      const max = this.cards.length - 1;
      this.reviewIndex = Math.max(0, Math.min(index, max));
      const card = this.cards[this.reviewIndex];
      const gap = parseFloat(getComputedStyle(this.track).gap || '0');
      const x = card.offsetLeft - this.cards[0].offsetLeft;
      const originalTransition = this.track.style.transition;
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${-x}px)`;
      if (!animate) requestAnimationFrame(() => { this.track.style.transition = originalTransition; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.reviewIndex)));
    }

    initTimer() {
      const wrap = this.querySelector('[data-numia-timer-wrap]');
      const main = this.querySelector('[data-main-countdown]');
      const configuredDeadline = String(this.config?.deadline || '').trim();
      let end = NaN;
      let hasRealDeadline = false;
      if (/(Z|[+-]\d{2}:\d{2})$/i.test(configuredDeadline)) {
        end = Date.parse(configuredDeadline);
        hasRealDeadline = Number.isFinite(end);
      }
      // When no actual offer deadline is configured, this is a 20-minute
      // page countdown only. It must not be described as an expiring offer.
      if (!hasRealDeadline) end = Date.now() + 20 * 60 * 1000;
      const pad = value => String(value).padStart(2, '0');
      const update = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        if (main) {
          const h = main.querySelector('[data-main-hours]');
          const m = main.querySelector('[data-main-minutes]');
          const s = main.querySelector('[data-main-seconds]');
          if (h) h.textContent = pad(hours);
          if (m) m.textContent = pad(minutes);
          if (s) s.textContent = pad(seconds);
        }
        if (wrap) {
          wrap.hidden = !hasRealDeadline || remaining === 0;
          if (!wrap.hidden) {
            const h = wrap.querySelector('[data-hours]');
            const m = wrap.querySelector('[data-minutes]');
            const s = wrap.querySelector('[data-seconds]');
            if (h) h.textContent = pad(hours);
            if (m) m.textContent = pad(minutes);
            if (s) s.textContent = pad(seconds);
          }
        }
        if (remaining === 0) clearInterval(this.timer);
      };
      update();
      if (end > Date.now()) this.timer = setInterval(update, 1000);
    }
  }

  customElements.define('numia-pdp-rest', NumiaPdpRest);
})();

  } catch(e) { console.error(e); }
})();
})();
